import { EditWorkScheduleScreen } from "@/components/screens/settings/EditWorkScheduleScreen"
import { useUpdateAndRegenerateReport } from "@/queries/useReport"
import { useNavigate } from "@/router"
import { currentAuthAtom } from "@/state/auth"
import { periodDraftAtom } from "@/state/draft/period"
import { reportFormDraftAtom } from "@/state/report"
import { workingScheduleDraftAtom } from "@/state/draft/workingSchedule"
import { useAnalytics } from "@/hooks/use-analytics"
import { useAtom, useAtomValue } from "jotai"
import { useEffect } from "react"
import { PlainDate } from "@/utils/date"

export default function EditWorkSchedulePage() {
	const navigate = useNavigate()
	const auth = useAtomValue(currentAuthAtom)
	const [workSchedule, setWorkSchedule] = useAtom(workingScheduleDraftAtom)
	const form = useAtomValue(reportFormDraftAtom)
	const period = useAtomValue(periodDraftAtom)
	const { run, generating } = useUpdateAndRegenerateReport()
	const analytics = useAnalytics("Edit_Schedule")

	useEffect(() => {
		analytics.sendEvent("Step_Schedule__View")
	}, [])
	return (
		<EditWorkScheduleScreen
			reportId={auth.reportId}
			onSave={(data) => {
				setWorkSchedule(data)
				analytics.sendEvent("Step_Schedule__Save")
				run(form)
			}}
			value={workSchedule}
			reportDateRange={[
				PlainDate.from(period.range[0]),
				PlainDate.from(period.range[1]),
			]}
			onSaveLocal={(data) => {
				setWorkSchedule(data)
			}}
			savingInProcess={generating}
		/>
	)
}
